(function () {
  const STORAGE_KEY = 'mo_favorites';
  const PROXY_ENDPOINT = '/apps/favorites';

  function getLocal() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setLocal(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function union(a, b) {
    const set = new Set([...(a || []), ...(b || [])]);
    return Array.from(set);
  }

  // --- Server sync (requires app proxy at /apps/favorites) ---
  async function syncToServer(list) {
    if (!window.MOCustomerLoggedIn) return;
    try {
      await fetch(PROXY_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ favorites: list }),
        credentials: 'same-origin',
      });
    } catch (e) {
      // Silently fail — localStorage remains source of truth on this device
      console.warn('[MOFavorites] sync failed', e);
    }
  }

  // --- Initial merge with server data injected by Liquid ---
  function initialMerge() {
    const local = getLocal();
    const initial = Array.isArray(window.MOFavoritesInitial) ? window.MOFavoritesInitial : [];
    if (!window.MOCustomerLoggedIn) return local;

    const merged = union(local, initial);
    const changed = merged.length !== local.length || merged.length !== initial.length;
    setLocal(merged);

    // If localStorage had items the server didn't, push them up
    if (changed) syncToServer(merged);

    return merged;
  }

  function getFavorites() {
    return getLocal();
  }

  function setFavorites(list) {
    setLocal(list);
    updateUI();
    window.dispatchEvent(new CustomEvent('favorites:change', { detail: list }));
    syncToServer(list);
  }

  function isFavorite(handle) {
    return getLocal().includes(handle);
  }

  function toggleFavorite(handle) {
    if (!handle) return;
    const list = getLocal();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    setFavorites(list);
  }

  function updateUI() {
    const favs = getLocal();

    document.querySelectorAll('[data-favorites-count]').forEach((el) => {
      el.textContent = favs.length;
      el.classList.toggle('is-empty', favs.length === 0);
    });

    document.querySelectorAll('[data-favorite-btn]').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      const active = favs.includes(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-favorite-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(btn.dataset.productHandle);
  });

  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) updateUI();
  });

  function init() {
    initialMerge();
    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MOFavorites = { getFavorites, isFavorite, toggleFavorite };
})();
